import React from 'react';
import InfoTooltip from '@uikit/Info/InfoTooltip/InfoTooltip';

export const TooltipWrapper = ({
  children,
  tooltip,
  open,
  disableChildrenWrapper,
}: {
  children: React.ReactNode;
  tooltip?: string;
  open?: boolean;
  disableChildrenWrapper?: boolean;
}) => {
  if (!tooltip) {
    return <>{children}</>;
  }

  return (
    <InfoTooltip
      title={tooltip}
      className="info-shower"
      open={open}
      slotProps={
        open === undefined ? undefined : { transition: { timeout: 0 } }
      }
      childrenContainerStyle={{ flexDirection: 'column' }}
      disableChildrenWrapper={disableChildrenWrapper}
    >
      {disableChildrenWrapper ? (
        (children as React.ReactElement)
      ) : (
        <>{children}</>
      )}
    </InfoTooltip>
  );
};
